import GestaoCadastros from '../pages/GestaoCadastros/GestaoCadastros'
import AcsPorCidadao from '../pages/GestaoCadastros/AcsPorCidadao/AcsPorCidadao'
import CidadaosDesvinculados from '../pages/GestaoCadastros/CidadaosDesvinculados/Index.vue'
import CidadaosDuplicados from '../pages/GestaoCadastros/CidadaosDuplicados/CidadaosDuplicados'
import CidadaosDuplicadosPorEquipe from '../pages/GestaoCadastros/CidadaosDuplicados/PorEquipe'
import CidadaosDuplicadosPorEquipeAcs from '../pages/GestaoCadastros/CidadaosDuplicados/PorEquipeAcs'
import CidadaosSemAcs from '../pages/GestaoCadastros/CidadaosSemAcs'
import CadastrosSemCpf from '../pages/GestaoCadastros/CadastrosSemCpf/CadastrosSemCpf'
import CadastrosSemCpfPorEquipeAcs from '../pages/GestaoCadastros/CadastrosSemCpf/PorEquipeAcs'
import CadastrosSemCpfPorEquipe from '../pages/GestaoCadastros/CadastrosSemCpf/PorEquipe'
import CidadaosCnsInvalidos from '../pages/GestaoCadastros/CidadaosCnsInvalidos/Index'
import CidadaosDesatualizados from '../pages/GestaoCadastros/CidadaosDesatualizados/Index'

import CalculadoraDePessoas from '../pages/GestaoCadastros/CalculadoraDePessoas/Index'
import CalculadoraDePessoasPorEquipeAcs from '../pages/GestaoCadastros/CalculadoraDePessoas/PorEquipeAcs'
import CalculadoraDePessoasPorEquipe from '../pages/GestaoCadastros/CalculadoraDePessoas/PorEquipe'
import Obitos from '@/pages/GestaoCadastros/Obitos/Index'
import ObitosPorEquipeAcs from '@/pages/GestaoCadastros/Obitos/PorEquipeAcs'
import ObitosPorProfissional from '@/pages/GestaoCadastros/Obitos/PorProfissional'
import MudancaTerritorio from '@/pages/GestaoCadastros/MudancaTerritorio/Index'
import MudancaTerritorioPorEquipeAcs from '@/pages/GestaoCadastros/MudancaTerritorio/PorEquipeAcs'
import MudancaTerritorioProfissional from '@/pages/GestaoCadastros/MudancaTerritorio/PorProfissional'

export default [
  {
    path: '/gestao-cadastros',
    component: GestaoCadastros,
  },
  {
    path: '/acs-por-cidadao',
    component: AcsPorCidadao,
  },
  {
    path: '/cidadaos-desvinculados',
    component: CidadaosDesvinculados,
  },
  {
    path: '/cidadaos-duplicados',
    component: () =>
      import('@/pages/GestaoCadastros/CidadaosDuplicados/Template.vue'),
    children: [
      {
        path: '/cidadaos-duplicados',
        component: CidadaosDuplicados,
      },
      {
        path: '/cidadaos-duplicados/equipe/acs',
        component: CidadaosDuplicadosPorEquipeAcs,
      },
      {
        path: '/cidadaos-duplicados/equipe',
        component: CidadaosDuplicadosPorEquipe,
      },
    ],
  },
  {
    path: '/cidadaos-sem-acs',
    component: CidadaosSemAcs,
  },
  {
    path: '/cadastros-sem-cpf',
    component: () =>
      import('@/pages/GestaoCadastros/CadastrosSemCpf/Template.vue'),
    children: [
      {
        path: '/cadastros-sem-cpf',
        component: CadastrosSemCpf,
      },
      {
        path: '/cadastros-sem-cpf/equipe/acs',
        component: CadastrosSemCpfPorEquipeAcs,
      },
      {
        path: '/cadastros-sem-cpf/equipe',
        component: CadastrosSemCpfPorEquipe,
      },
    ],
  },
  {
    path: '/cidadaos-cns-invalidos',
    component: CidadaosCnsInvalidos,
  },
  {
    path: '/cidadaos-desatualizados',
    component: CidadaosDesatualizados,
  },
  {
    path: '/calculadora-de-pessoas',
    component: () =>
      import('@/pages/GestaoCadastros/CalculadoraDePessoas/Template.vue'),
    children: [
      {
        path: '/calculadora-de-pessoas',
        component: CalculadoraDePessoas,
      },
      {
        path: '/calculadora-de-pessoas/equipe/acs',
        component: CalculadoraDePessoasPorEquipeAcs,
      },
      {
        path: '/calculadora-de-pessoas/equipe',
        component: CalculadoraDePessoasPorEquipe,
      },
    ],
  },
  {
    path: '/obitos',
    component: () => import('@/pages/GestaoCadastros/Obitos/Template.vue'),
    children: [
      {
        path: '/obitos',
        component: Obitos,
      },
      {
        path: '/obitos/profissional',
        component: ObitosPorProfissional,
      },
      {
        path: '/obitos/equipe/acs',
        component: ObitosPorEquipeAcs,
      },
    ],
  },
  {
    path: '/mudanca_territorio',
    component: () =>
      import('@/pages/GestaoCadastros/MudancaTerritorio/Template.vue'),
    children: [
      {
        path: '/mudanca_territorio/',
        component: MudancaTerritorio,
      },
      {
        path: '/mudanca_territorio/profissional',
        component: MudancaTerritorioProfissional,
      },
      {
        path: '/mudanca_territorio/equipe/acs',
        component: MudancaTerritorioPorEquipeAcs,
      },
    ],
  },
]
